import { countriesFilters } from "./countriesFilters";

export const countries = {
  namespaced: true,
  modules: {
    countriesList: countriesFilters
  }
};
